import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-restriction',
  templateUrl: './delete-restriction.component.html',
})
export class DeleteRestrictionComponent {
  constructor(
    public dialogRef: MatDialogRef<DeleteRestrictionComponent>
  ) {}

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
} 